<template>
  <div id="printerDivOrderLog">
    <div class="receipt-header">
      <span class="company-name">{{companyName}}</span>
      <span class="report-title">Ciro Raporu</span>
      <span class="report-date">Tarih: {{reportDate}}</span>
    </div>
    
    <table class="receipt-table">
      <thead>
        <tr>
          <th class="text-left">Ödeme</th>
          <th class="text-center">Adet</th>
          <th class="text-right">Tutar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tr, index) in sumOfOrders" :key="index">
          <td class="text-left">{{ tr.paymentName }}</td>
          <td class="text-center">{{ tr.totalCount }}</td>
          <td class="text-right">{{ $toCurrency(tr.totalPrice) }}</td>
        </tr>
        <tr v-if="sumOfExpenses.length > 0" class="border-top">
          <td class="text-left">Gider</td>
          <td class="text-center">{{sumOfExpenses.length}}</td>
          <td class="text-right">{{ $toCurrency(getTotalExpensePrice) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="receipt-footer border-top-double">
      <div class="footer-row">
        <span class="bold">Toplam Net Ciro:</span>
        <span class="bold">{{ $toCurrency(getTotalPrice) }}</span>
      </div>
    </div>
  </div>
</template>
<script src="https://www.google.com/cloudprint/client/cpgadget.js" />
<script>
  import print from 'print-js';
  import companyInfo from '../../../../model/constants/companyInfo';
  export default {
    props: {
      sumOfOrders: {
        type: Array,
        required: false
      },
      sumOfExpenses: {
        type: Array,
        required: false
      },
      getTotalPrice:{
        type:Number,
        required:false
      },
      getTotalExpensePrice:{
        type:Number,
        required:false
      },
      reportDate:{
        type: String,
        required:false
      }
    },
    data() {
      return {
        companyName: companyInfo.name
      }
    },
    methods: {
      printTotalOrderLogs() {
        try {
          const style = `
              #printerDivOrderLog { font-family: 'Courier New', Courier, monospace; width: 80mm; padding: 5mm; color: #000; background: #fff; position: relative !important; left: 0 !important; top: 0 !important; }
              .receipt-header { text-align: center; margin-bottom: 5mm; }
              .company-name { display: block; font-weight: bold; font-size: 18px; text-transform: uppercase; }
              .report-title { display: block; font-weight: bold; font-size: 16px; margin-top: 2mm; }
              .report-date { display: block; font-size: 14px; margin-top: 2mm; }
              .receipt-table { width: 100%; border-collapse: collapse; margin-top: 5mm; font-size: 14px; }
              .receipt-table th { border-bottom: 1px dashed #000; padding: 2mm 0; font-weight: bold; text-align: left; }
              .receipt-table td { padding: 2mm 0; }
              .text-left { text-align: left; }
              .text-center { text-align: center; }
              .text-right { text-align: right; }
              .border-top { border-top: 1px dashed #000; }
              .border-top-double { border-top: 3px double #000; margin-top: 2mm; padding-top: 2mm; }
              .receipt-footer { margin-top: 5mm; }
              .footer-row { display: flex; justify-content: space-between; font-size: 16px; }
              .bold { font-weight: bold; }
            `;

          print({
            showModal: false,
            printable: 'printerDivOrderLog',
            type: 'html',
            header: null,
            style: style,
            scanStyles: false
          });
        } catch (e) {
          console.error("Print error:", e);
        }
      },
    }
  }

</script>

<style scoped>
  #printerDivOrderLog {
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 80mm;
  }
</style>
